import { Navigation, Sidebar } from "../components/navigation";
// FIX: Add useSelector to the import
import { useDispatch, useSelector } from "react-redux";

import { Login } from "../pages";
import { Outlet } from "react-router-dom";
import { responsiveness } from "../assets/styles/parameters";
import { setUser } from "../redux/user";
import styled from "styled-components";
import { useAuth } from "react-oidc-context";
import { useEffect } from "react";

export const ProtectedRoutes = () => {
  const auth = useAuth();
  const dispatch = useDispatch();

  // FIX: Grab the token from Redux to monitor its status
  const reduxToken = useSelector((state) => state.user?.user?.token);

  useEffect(() => {
    const removeExpiringHandler = auth.events.addAccessTokenExpiring(() => {
      if (
        window.confirm(
          "Your session is about to expire due to inactivity. Press OK to stay signed in, or Cancel to log out.",
        )
      ) {
        auth.signinSilent();
      } else {
        auth.signoutRedirect();
      }
    });

    return () => {
      removeExpiringHandler();
    };
  }, [auth]);

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      dispatch(
        setUser({
          authenticated: true,
          user: auth.user.profile,
          token: auth.user.access_token,
        }),
      );
    }
  }, [auth.isAuthenticated, auth.user, dispatch]);

  if (auth.isLoading) {
    return (
      <Layout>
        <LoadingMessage>Verifying session...</LoadingMessage>
      </Layout>
    );
  }

  if (auth.error) {
    return (
      <Layout>
        <ErrorMessage>Authentication Error: {auth.error.message}</ErrorMessage>
      </Layout>
    );
  }

  // If OIDC says they are not logged in, show the login screen
  if (!auth.isAuthenticated) {
    return <Login />;
  }

  // FIX: Do NOT render the child pages until the token is safely stored in Redux!
  // This physically prevents child components from firing API requests too early.
  if (!reduxToken) {
    return (
      <Layout>
        <LoadingMessage>Preparing dashboard...</LoadingMessage>
      </Layout>
    );
  }

  // Once the token is in Redux, it's safe to render the app
  return (
    <Layout>
      <Sidebar />
      <Navigation />
      <Outlet />
    </Layout>
  );
};

const Layout = styled.div`
  display: grid;
  grid-template-areas:
    "sidebar navigation navigation navigation"
    "sidebar header header header"
    "sidebar main main main"
    "sidebar main main main"
    "sidebar main main main";
  grid-template-columns: 5% 1fr 1fr 1fr;

  /*
   * Tablet + Mobile (≤1024px):
   * Sidebar becomes a fixed full-screen overlay (toggled by the hamburger),
   * so it no longer needs a grid slot. Content fills the full width.
   */
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "navigation"
      "header"
      "main";
  }
`;

// Added some basic styled components to replace the empty divs
const LoadingMessage = styled.div`
  grid-area: main;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  height: 100vh;
`;

const ErrorMessage = styled(LoadingMessage)`
  color: red;
`;
